export interface Category {
  name: string;
  slug: string;
  icon: string;
  description: string;
  articleCount: number;
}

export const categories: Category[] = [
  {
    name: "企业内幕",
    slug: "corporate-insider",
    icon: "ri-building-2-line",
    description: "互联网、科技企业内部的真实爆料，HR黑幕、管理乱象、商业竞争内情。",
    articleCount: 3,
  },
  {
    name: "金融黑幕",
    slug: "financial-scandal",
    icon: "ri-money-dollar-circle-line",
    description: "金融行业骗局、资本运作灰幕、投资陷阱、地下金融产业链深度调查。",
    articleCount: 2,
  },
  {
    name: "娱乐揭秘",
    slug: "entertainment-expose",
    icon: "ri-movie-2-line",
    description: "娱乐圈资本运作、流量造假、艺人合同陷阱、综艺节目剧本内幕。",
    articleCount: 1,
  },
  {
    name: "政商关系",
    slug: "politics-business",
    icon: "ri-government-line",
    description: "政商利益输送、地方保护主义、权力寻租网络深度调查与解析。",
    articleCount: 1,
  },
  {
    name: "社会民生",
    slug: "society-livelihood",
    icon: "ri-heart-pulse-line",
    description: "食品安全、教育公平、医疗黑幕等与大众生活息息相关的内幕调查。",
    articleCount: 2,
  },
  {
    name: "消费陷阱",
    slug: "consumer-trap",
    icon: "ri-shopping-cart-2-line",
    description: "医美、奢侈品、在线教育等消费领域的暴利内幕与行业陷阱揭秘。",
    articleCount: 3,
  },
  {
    name: "犯罪揭秘",
    slug: "crime-expose",
    icon: "ri-spy-line",
    description: "跨国犯罪集团组织架构、新型诈骗手法、网络黑产链条深度起底。",
    articleCount: 1,
  },
  {
    name: "教育黑幕",
    slug: "education-scandal",
    icon: "ri-book-open-line",
    description: "学术造假、论文代写、教育产业灰色地带全方位调查报道。",
    articleCount: 1,
  },
];